import { api } from '@/api';
import { handleQueryLifecycle } from '@/api/utils.ts';
import { setChatId } from '@/store';

export interface CreateChatRequest {
  userId: string;
  matterId?: string;
}

export interface CreateChatResponse {
  chatId: string;
}

export const createChatApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCreateChat: builder.mutation<CreateChatResponse, CreateChatRequest>({
      query: ({ userId, matterId }) => ({
        url: '/chat/create',
        method: 'POST',
        body: {
          user_id: userId,
          matter_id: matterId,
        },
      }),
      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        await handleQueryLifecycle(queryFulfilled, (data) => {
          dispatch(setChatId(data));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostCreateChatMutation } = createChatApi;
